import { API } from "@aws-amplify/api";

export const getJourney = `query MyQuery ($input: cidInput!){
  getJourneyPath(input: $input)
    
}`;

export async function getJourneyDetails(params?: any): Promise<any> {
  try {

    const response: any = await API.graphql({
      query: getJourney, variables: {
        input: params
      }
    });
    return response.data.getJourneyPath
  } catch (error) {
    console.log("getJourney", error);
  }
}

export const getAckJourney = `query ($input: cidInput!) {
  getAckJourneyPath(input: $input)
  }`;

export const getAckJourneyPath = async (params: any) => {
  try {
    const response: any = await API.graphql({
      query: getAckJourney, variables: {
        input: params
      }
    });
    return response.data.getAckJourneyPath
  } catch {

  }
}